module.exports = __webpack_public_path__ + "img/logo-light.4e76a88c.png";